/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import clsx from "clsx";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import {
  Dialog,
  DialogTitle as MuiDialogTitle,
  TextField,
  DialogContent,
  MenuItem,
  DialogActions,
  Button,
  Typography,
  IconButton,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

import {
  sendSkill,
  sendEditSkill,
  deleteSkill,
} from "../../../../../store/actions";

const useStyles = makeStyles((theme) => ({
  field: {
    marginTop: theme.spacing(1),
  },
  cardActions: {
    justifyContent: "space-between",
  },
  btnDelete: {
    color: "#fff",
    background: theme.palette.red.color500,
    "&:hover": {
      backgroundColor: theme.palette.red.color700,
    },
  },
}));

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const validationSchema = yup.object().shape({
  name: yup.string().required("Wajib diisi"),
  level: yup.string().required("Wajib diisi"),
});

const DialogSkill = ({
  dialog,
  onClose,
  sendSkill,
  sendEditSkill,
  deleteSkill,
  hcis,
}) => {
  const classes = useStyles();
  const params = useParams();

  const { register, errors, handleSubmit, control, setValue } = useForm({
    resolver: yupResolver(validationSchema),
    shouldUnregister: false,
  });

  const handleDelete = (id) => {
    if (hcis) {
      deleteSkill(id, params.userId);
    } else {
      deleteSkill(id);
    }
    onClose();
  };

  const onSubmit = (data, e) => {
    if (dialog.edit) {
      if (hcis) {
        sendEditSkill(data, dialog.value.id, params.userId);
      } else {
        sendEditSkill(data, dialog.value.id);
      }
    } else {
      if (hcis) {
        sendSkill(data, params.userId);
      } else {
        sendSkill(data);
      }
    }
    e.target.reset();
    setValue("level", "");
    onClose();
  };

  useEffect(() => {
    if (dialog.edit) {
      setValue("name", dialog.value.name);
      setValue("level", dialog.value.level);
      return;
    }
    setValue("name", "");
    setValue("level", "");
  }, [dialog.edit]);

  return (
    <Dialog open={dialog.open} onClose={onClose} maxWidth="md" fullWidth>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle onClose={onClose}>
          {!dialog.edit ? "Tambah" : "Edit"} Keahlian
        </DialogTitle>
        <DialogContent dividers>
          <TextField
            fullWidth
            name="name"
            label="Nama Keahlian"
            inputRef={register}
            error={!!errors.name}
            helperText={!!errors.name && errors.name.message}
          />
          <Controller
            control={control}
            name="level"
            defaultValue=""
            render={({ onChange, ref, value }) => (
              <TextField
                className={classes.field}
                fullWidth
                select
                defaultValue=""
                label="Tingkat Keahlian"
                inputRef={ref}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                error={!!errors.level}
                helperText={!!errors.level && errors.level.message}
              >
                <MenuItem value="" disabled></MenuItem>
                <MenuItem value="Dasar/Basic">Dasar/Basic</MenuItem>
                <MenuItem value="Sedang/Intermediete">Sedang/Intermediete</MenuItem>
                <MenuItem value="Baik/Advance">Baik/Advance</MenuItem>
                <MenuItem value="Sangat Baik/Expert">Sangat Baik/Expert</MenuItem>
              </TextField>
            )}
          />
        </DialogContent>
        <DialogActions className={clsx({ [classes.cardActions]: dialog.edit })}>
          {dialog.edit && (
            <Button
              className={classes.btnDelete}
              variant="contained"
              onClick={() => handleDelete(dialog.value.id)}
            >
              Delete Data
            </Button>
          )}
          <Button variant="contained" color="primary" type="submit">
            {!dialog.edit ? "Simpan" : "Edit Data"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default connect(null, { sendSkill, sendEditSkill, deleteSkill })(
  DialogSkill
);
